import {
  Button,
  Card,
  Col,
  Form,
  message,
  Modal,
  notification,
  Space,
  Table,
  Tag,
} from "antd";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CustomUpload from "../../../../utils/CustomUpload";
import GlobalContext from "../../../../context/GlobalContext";
import { CheckOutlined, CloseOutlined, EditOutlined } from "@ant-design/icons";
import { nanoid } from "nanoid";
import axiosInstance from "../../../../utils/axios";
import {
  updateActionAffaire,
  updateStatusApprenants,
  uploadDocumentAffaire,
} from "../../../../api/geoprod";
import { useLoader } from "../../../../context/LoaderContext";

const ModalUploadPVCertifs = (props) => {
  const { openModal, setOpenModal, setPv, pv } = props;
  const { t } = useTranslation();
  const { form } = useContext(GlobalContext);
  const [modalVisible, setModalVisible] = useState({});
  const [selectedDiplomaFiles, setSelectedDiplomaFiles] = useState([]);
  const [currentApprenantId, setCurrentApprenantId] = useState();
  const { setIsLoading } = useLoader();
  const handleValidate = async () => {
    const openIds = openModal?.data?.map((item) => item.id);

    // Vérifier que chaque ID de openModal est présent dans modalVisible
    const incompleteValidation = openIds.some(
      (id) => modalVisible[id] !== true && modalVisible[id] !== false
    );

    if (incompleteValidation) {
      message.error(
        "Tous les apprenants doivent être validés ou refusés avant de continuer."
      );
      return;
    }
    // Vérifier que tous les apprenants validés (true) ont bien un diplôme
    const validatedWithoutDiploma = openIds.filter(
      (id) => modalVisible[id] === true && !selectedDiplomaFiles[id]
    );

    if (validatedWithoutDiploma.length > 0) {
      message.error(
        "Veuillez téléverser un diplôme pour tous les apprenants acceptés."
      );
      return;
    }

    if (
      pv === "" &&
      openModal?.etat_affaire !==
        import.meta.env
          .VITE_APP_ID_STATUS_COMPLEMENT_DOSSIER_SESSION_FORMATION_NON_HOMOLOGUEE_CONTINUE
    ) {
      message.error("Veuillez téléverser le pv de la session");
      return;
    }

    setIsLoading(true);

    // Construction du tableau d'apprenants
    const apprenants = openIds.map((id) => ({
      id_apprenant: id,
      statut: modalVisible[id]
        ? import.meta.env.VITE_APP_ID_STATUS_APPRENANT_ACCEPTE
        : import.meta.env.VITE_APP_ID_STATUS_APPRENANT_ANNULE,
    }));

    const payload = {
      apprenants,
      id_formation: parseInt(sessionStorage.getItem("id_formation_apprenants")),
    };

    const data = await updateStatusApprenants(payload);

    if (data) {
      const id_affaire = sessionStorage.getItem(
        "id_affaire_to_upload_docs_session"
      );
      const idStatus = import.meta.env
        .VITE_APP_ID_STATUS_PV_AJOUTE_SESSION_FORMATION_NON_HOMOLOGUEE_CONTINUE;
      const dataStatus =await updateActionAffaire({
        id_affaire,
        id_status: idStatus,
      });
      if (dataStatus) {
        setIsLoading(false);
        setOpenModal([]);
        window.location.reload();
      }
    } else {
      notification.error({
        message: "Erreur",
        description:
          "Erreur lors de l'enregsitrement des status des apprenants",
      });
    }
  };

  const myCustomRequest = (id, { file, onSuccess }) => {
    const formData = new FormData();
    const newFileName = `DOC-${nanoid(12)}.${file.name.split(".").pop()}`;
    const renamedFile = new File([file], newFileName, { type: file.type });
    formData.append("id_apprenant", id);
    formData.append("document", renamedFile);
    axiosInstance
      .post(
        `${import.meta.env.VITE_APP_GEOPROD_API}/upload_doc_apprenant`,
        formData,
        {
          headers: {
            Idsession: JSON.parse(localStorage.getItem("-x-token-user"))
              ?.Acces_Token,
          },
        }
      )
      .then((res) => {
        onSuccess(res);
        setSelectedDiplomaFiles((prev) => ({
          ...prev,
          [currentApprenantId]: res?.data?.url,
        }));
      });

    // try {
    //   const res = await uploadDocumentAffaire(formData);
    //   const fileUrl = res.data.path;

    //   form.setFieldsValue({
    //     document_key: fileUrl,
    //   });

    //   onSuccess(res);
    // } catch (err) {
    //   console.error(err);
    //   onError(err);
    // }
  };

  const customRequestPv = async (id, { file, onSuccess, onError }) => {
    const id_affaire = sessionStorage.getItem(
      "id_affaire_to_upload_docs_session"
    );
    const id_type_doc = import.meta.env
      .VITE_APP_ID_PORTE_DOCUMENT_PV_SESSION_NON_HOMOLOGUEE_CONTINUE;

    const formData = new FormData();
    const newFileName = `DOC-${nanoid(12)}.${file.name.split(".").pop()}`;
    const renamedFile = new File([file], newFileName, { type: file.type });

    formData.append("id_affaire", id_affaire);
    formData.append("id_type_doc", id_type_doc);
    formData.append("file[]", renamedFile);
    formData.append("name_doc", "document_name");
    formData.append("key", "document_key");

    try {
      const res = await uploadDocumentAffaire(formData);
      const fileUrl = res.data.path;

      form.setFieldsValue({
        document_key: fileUrl,
      });
      setPv(fileUrl);

      onSuccess(res);
    } catch (err) {
      console.error(err);
      onError(err);
    }
  };
  const renderStatusTag = (status) => {
    const accepte = parseInt(
      import.meta.env.VITE_APP_ID_STATUS_APPRENANT_ACCEPTE
    );
    const refuse = parseInt(
      import.meta.env.VITE_APP_ID_STATUS_APPRENANT_ANNULE
    );
    switch (status) {
      case accepte:
        return <Tag color="#26b6a7">Accepté</Tag>;
      case refuse:
        return <Tag color="#ff808b">Refusé</Tag>;
      default:
        return <Tag color="#ffb836">À vérifier</Tag>;
    }
  };
  const showUploadModal = (participantId) => {
    // const participant = openModal.find((p) => p.id === participantId);
    // setSelectedDiplomaFiles(participant.diploma || null);
    setCurrentApprenantId(participantId);
    setModalVisible((prev) => ({
      ...prev,
      [participantId]: true,
    }));
  };

  const columns = [
    { title: "Nom", dataIndex: "name", key: "name" },
    { title: "Prénom", dataIndex: "surname", key: "surname" },
    {
      title: "Date de naissance",
      dataIndex: "DN",
      key: "DN",
    },
    {
      title: "CIN/extrait_naissance",
      key: "cin",
      render: (_, record) => {
        return record?.data_from?.typeIdentifiant === "cin"
          ? record?.cin
          : record?.extrait_naissance;
      },
    },
    {
      title: "Niveau",
      key: "niveau",
      render: (_, record) => {
        return record?.data_from?.niveau
          ? record.data_from.niveau
          : "Non renseigné";
      },
    },
    {
      title: "Statut",
      key: "status",
      render: (_, record) => renderStatusTag(record.id_statut_apprenant),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          {(modalVisible[record.id]===false ||
            record?.id_statut_apprenant ===
              parseInt(import.meta.env.VITE_APP_ID_STATUS_APPRENANT_ANNULE)) && (
            <Button
              icon={record.diploma ? <EditOutlined /> : <CheckOutlined />}
              type="text"
              onClick={() => showUploadModal(record.id)}
              style={{ color: "#26b6a7" }}
            >
              {"Accepter"}
            </Button>
         )} 
          {(modalVisible[record.id] ||
            record?.id_statut_apprenant ===
              parseInt(import.meta.env.VITE_APP_ID_STATUS_APPRENANT_ACCEPTE)) && (
            <Button
              style={{ color: "#ff808b" }}
              icon={<CloseOutlined />}
              type="text"
              onClick={() => {
                setModalVisible((prev) => ({
                  ...prev,
                  [record.id]: false,
                }));

                setSelectedDiplomaFiles((prev) => {
                  const copy = { ...prev };
                  delete copy[record.id];
                  return copy;
                });
              }}
            >
              Refuser
            </Button>
     )} 
          {/* {record.status === "accepted" && record.diploma && (
            <Tooltip title="Voir diplôme">
              <FileDoneOutlined
                style={{ cursor: "pointer", color: "#025cab" }}
                onClick={() => window.open(URL.createObjectURL(record.diploma))}
              />
            </Tooltip>
          )} */}

          {(modalVisible[record.id] ) && (
            // <Form.Item
            //   label="test"
            //   style={{ width: "100%" }}
            //   name={["PvSession", record.id]}
            //   rules={[{ required: true, message: "Veuillez remplir ce champ" }]}
            // >
            <CustomUpload
              field={{
                buttonName: "Téléverser le diplome de cet apprenant",
                name: `PvSessionUpload_${record.id}`,
              }}
              multiple={false}
              accept=".png,.jpg,.jpeg,.pdf"
              customRequest={myCustomRequest}
              id={record.id}
              setSelectedDiplomaFiles={setSelectedDiplomaFiles}
              type="diplome"
              showIcon={true}
              value={record?.documents?.content_diplome}
            />
            // </Form.Item>
          )}
          {modalVisible[record.id] === false && (
            <Tag color="#ff808b">Refusé</Tag>
          )}
        </Space>
      ),
    },
  ];
  return (
    <>
      <Modal
        //   title={
        //     <div
        //       style={{ fontSize: "18px", fontWeight: "bold", textAlign: "center" }}
        //     >
        //       {t("Choix du type de modification")}
        //     </div>
        //   }
        open={openModal?.data?.length > 0}
        onCancel={() => setOpenModal([])}
        width={1800}
        footer={null}
        centered
      >
        <Form form={form} layout="vertical" onFinish={handleValidate}>
          <Col lg={24}>
            <CustomUpload
              field={{
                buttonName: t("Téléverser une pièce jointe"),
                title: "Téléverser le pv de la session",
                name: "PvSessionUpload",
              }}
              multiple={false}
              accept=".png,.jpg,.jpeg,.pdf"
              customRequest={customRequestPv}
              id={null}
              setSelectedDiplomaFiles={null}
              type="pv"
              showIcon={true}
              value={pv}
            />
          </Col>
          <Card bordered={false}>
            <h2>{t("Liste des participants")}</h2>
            <Table
              dataSource={openModal?.data}
              columns={columns}
              rowKey="id"
              pagination={false}
            />
          </Card>
          <Button key="cancel" onClick={() => setOpenModal([])}>
            {t("Annuler")}
          </Button>
          <Button key="validate" type="primary" htmlType="submit">
            {openModal?.etat_affaire !==
            import.meta.env
              .VITE_APP_ID_STATUS_COMPLEMENT_DOSSIER_SESSION_FORMATION_NON_HOMOLOGUEE_CONTINUE
              ? t("Valider")
              : t("Compléter la demande")}
          </Button>
        </Form>
      </Modal>
      {/* <Modal
      //   title={
      //     <div
      //       style={{ fontSize: "18px", fontWeight: "bold", textAlign: "center" }}
      //     >
      //       {t("Choix du type de modification")}
      //     </div>
      //   }
      open={modalVisible!==""}
      onCancel={() => setModalVisible("")}
      width={800}
      footer={[
        <Button key="cancel" onClick={() => setModalVisible("")}>
          {t("Annuler")}
        </Button>,
        <Button key="validate" type="primary" onClick={handleValidate}>
          {t("Valider")}
        </Button>,
      ]}
      centered
    >
      <Form form={form} layout="vertical">
        <Col lg={24}>
          <Form.Item
            style={{ width: "100%" }}
            name="PvSession"
            label={
              <span style={{ whiteSpace: "pre-line", display: "flex" }}>
                Téléverser le pv de la session
              </span>
            }
            rules={[{ required: true, message: "Veuillez remplir ce champ" }]}
          >
            <CustomUpload
              field={{
                buttonName: "Téléverser une pièce jointe",
                title: "Téléverser le pv de la session",
                name: "PvSessionUpload",
              }}
              multiple={false}
              accept=".png,.jpg,.jpeg,.pdf"
              id_affaire={sessionStorage.getItem(
                "id_affaire_to_upload_docs_session"
              )}
              id_type_doc={
                import.meta.env
                  .VITE_APP_ID_PORTE_DOCUMENT_CERTIFICAT_SESSION_NON_HOMOLOGUEE_CONTINUE
              }
            />
          </Form.Item>
        </Col>
        
      </Form>
    </Modal> */}
    </>
  );
};

export default ModalUploadPVCertifs;
